export default {
	invalidProps: '最小日期不能大于最大日期',
	invalidDate: '无效的日期格式',
	tooEarly: '所选日期不能小于最小日期',
	tooLate: '所选日期不能大于最大日期'
};
